export default "__VITE_ASSET__BAOKbx2x__"